import api from '../lib/api';
import type { ApiResponse } from '@maios/shared';

export interface DashboardSummary {
  totalOrganizations: number;
  totalUsers: number;
  activeOrganizations: number;
  activeOrganizationRate: number;
  openBugReports: number;
  openBugReportsDelta: number;
  planDistribution: Record<string, number>;
  conversionRate: number;
  totalStorageUsed: number;
  totalStorageLimit: number;
  storageUsageRate: number;
  organizationsDelta: number;
  usersDelta: number;
}

export interface DashboardTrends {
  period: string;
  labels: string[];
  datasets: {
    newOrganizations: number[];
    newUsers: number[];
    bugReports: number[];
    planDistribution: Record<string, number | number[]>;
  };
}

export interface DashboardRecent {
  recentOrganizations: Array<{ id: string; name: string; slug: string; planType: string; createdAt: string }>;
  recentBugReports: Array<{ id: string; title: string; category: string; status: string; createdAt: string; organization: { name: string } | null }>;
  recentProConversions: Array<{ id: string; name: string; slug: string; planType: string; planStartedAt: string; createdAt: string }>;
}

export async function getSummary(): Promise<DashboardSummary> {
  const res = await api.get<ApiResponse<DashboardSummary>>('/admin/dashboard/summary');
  return res.data.data!;
}

export async function getRecent(): Promise<DashboardRecent> {
  const res = await api.get<ApiResponse<DashboardRecent>>('/admin/dashboard/recent');
  return res.data.data!;
}

export async function getTrends(params: { period?: string; days?: number } = {}): Promise<DashboardTrends> {
  const query = new URLSearchParams();
  if (params.period) query.set('period', params.period);
  if (params.days) query.set('days', String(params.days));
  const res = await api.get<ApiResponse<DashboardTrends>>(`/admin/dashboard/trends?${query}`);
  return res.data.data!;
}
